module.exports = __webpack_public_path__ + "img/palm-x6-plus.9cf8b4eb.png";